import React from 'react';
import CardContainer from 'src/components/common/CardContainer.redesign';
import Card from 'src/components/common/Card.redesign';
import LeaseGenerationTractDetail from 'src/models/leasing/LeaseGenerationTractDetail';
import OwnershipContactCategoryForm from 'src/models/OwnershipContactCategoryForm';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import { useForm } from 'react-hook-form';
import AgreementUtil from 'src/util/AgreementUtil';

interface IOwnershipTractListProps {
    tracts?: Array<LeaseGenerationTractDetail>;
    clientNumber: number;
    projectNumber: number;
    selectedOwnershipIds: Array<number>;
    projectType?: 'Mineral' | 'Surface';
    leaseBuyers?: Array<{ value: number; label: string }>;
    contactCategories?: OwnershipContactCategoryForm;

    updateSelectedOwnershipIds: (ownershipId: number) => void;
    selectAllOwnerships: (selectAll: boolean) => void;
}

const OwnershipTractList = (props: IOwnershipTractListProps) => {
    const { register, getValues } = useForm();

    const handleCheckBoxChange = () => {
        let ref = getValues();
        props.selectAllOwnerships(ref.selectAllTracts);
    };
    
    return (
        <CardContainer className="owner-tracts-results">
            <form>
                <RHFCheckbox name="selectAllTracts" label="Select All" onClick={handleCheckBoxChange} register={register} />
            </form>
            {props.tracts &&
                props.tracts.map((x: LeaseGenerationTractDetail, index) => {
                    const badge = AgreementUtil.getGlobalId(x, x.parentTractType);
                    return (
                        <Card
                            key={`${index} ${x.ownershipId}`}
                            badge={badge}
                            onClick={() => props.updateSelectedOwnershipIds(x.ownershipId)}
                            className={props.selectedOwnershipIds.includes(x.ownershipId) ? 'selected spaced' : 'spaced'}
                            newContext={true}
                            rightBadgePanel={x.county?.name}
                        >
                            <div style={{ margin: '.2rem' }}>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ marginRight: '1rem' }}>Lease Buyer:</div>
                                    <div className="owner-tract-legal-description">{props.leaseBuyers ? props.leaseBuyers.find(lb => lb.value === x.leaseBuyer)?.label : ''}</div>
                                </div>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ marginRight: '1rem' }}>Contact Category:</div>
                                    {/* tslint:disable-next-line:max-line-length */}
                                    <div className="owner-tract-legal-description">{props.contactCategories ? props.contactCategories.categories.find(cc => cc.id === x.ownershipContactCategoryId)?.name : ''}</div>
                                </div>
                            </div>
                            <div style={{ margin: '.2rem' }}>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ marginRight: '1rem' }}>Legal Description:</div>
                                    <div className="owner-tract-legal-description">{x.legalDescription}</div>
                                </div>
                            </div>
                            <div style={{ margin: '.2rem', display: 'flex', justifyContent: 'space-between', borderTop: '1px solid lightgrey' }}>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ marginRight: '1rem' }}>Gross:</div>
                                    <div>{x.grossAcres}</div>
                                </div>

                                <div style={{ display: 'flex' }}>
                                    <div style={{ marginRight: '1rem' }}>Interest:</div>
                                    <div>{x.decimalInterest}</div>
                                </div>

                                <div style={{ display: 'flex' }}>
                                    <div style={{ marginRight: '1rem' }}>Net:</div>
                                    <div>{x.grossAcres * x.decimalInterest}</div>
                                </div>
                            </div>
                        </Card>
                    );
                })}
            {props.tracts && props.tracts?.length === 0 && <div>No Tracts for this Owner</div>}
        </CardContainer>
    );
};

export default OwnershipTractList;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/OwnershipTractList.tsx